import Command from "@ckeditor/ckeditor5-core/src/command";

export default class InsertComment extends Command {
  execute() {
    this.editor.model.change((writer) => {
        const startSelection = this.editor.model.document.selection.getFirstPosition();
        const endSelection = this.editor.model.document.selection.getLastPosition();
        const range = writer.createRange(startSelection, endSelection);

        let str = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
            var e = (16 * Math.random()) | 0;
                return ("x" == t ? e : (3 & e) | 8).toString(16);
            }
        )

        let r = "comment:Chats:" + str;
        
        writer.addMarker(r, { range: range, usingOperation: !0 });

        if (this.editor.widgetInstance)
            this.editor.widgetInstance.createChat(str);
    });
  }
}
